"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var utils_1 = require("../utils");

var moment_1 = __importDefault(require("moment"));

var GenericImporter =
/** @class */
function (_super) {
  __extends(GenericImporter, _super);

  function GenericImporter(reader) {
    var _this = _super.call(this) || this;

    _this.fields = new Map();
    _this.reader = reader;
    return _this;
  }

  GenericImporter.prototype.dryrun = function () {
    var _this = this;

    return this.checkFields().then(function (r) {
      if (r.errors.length) {
        return Promise.resolve(r);
      } else {
        return _this.doDryRun();
      }
    });
  };

  GenericImporter.prototype.checkFields = function () {
    var e_1, _a;

    var missings = [];

    try {
      for (var _b = __values(this.fields.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var field = _c.value;

        if (field.required && !field.map) {
          missings.push(field.name);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    var r = {
      messages: [],
      errors: [],
      count: 0,
      canCreate: false
    };

    if (missings.length) {
      r.errors.push("Correspondance requise pour les champs : " + missings.join(", "));
    }

    return Promise.resolve(r);
  };

  GenericImporter.prototype.getFields = function () {
    return this.fields;
  };

  GenericImporter.prototype.setMapping = function (mapping) {
    var e_2, _a;

    var _this = this;

    try {
      for (var _b = __values(this.fields.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
        var field = _c.value;
        field.map = undefined;
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    mapping.forEach(function (v) {
      if (_this.fields.has(v.dest)) {
        _this.fields.get(v.dest).map = v.src;
      }
    });
    return this;
  };

  GenericImporter.prototype.generatePreview = function () {
    var _this = this;

    return this.checkFields().then(function (r) {
      if (r.errors.length) {
        return Promise.reject("Erreur de validation des champs");
      } else {
        return new Promise(function (res, rej) {
          var headers = Array.from(_this.fields.values(), function (v) {
            return v.map ? v.name : "";
          }).filter(function (v) {
            return Boolean(v);
          });
          var keys = Array.from(_this.fields.entries(), function (_a) {
            var _b = __read(_a, 2),
                k = _b[0],
                v = _b[1];

            return v.map ? k : "";
          }).filter(function (v) {
            return Boolean(v);
          });
          var head = [];

          var _loop_1 = function _loop_1(i) {
            var data = _this.rowToData(_this.reader.getRow(i));

            head.push(keys.map(function (k) {
              return _this.valueToString(data[k]);
            }));
          };

          for (var i = 1; i <= Math.min(3, _this.reader.getRowCount()); i++) {
            _loop_1(i);
          }

          var tail = [];

          var _loop_2 = function _loop_2(i) {
            var data = _this.rowToData(_this.reader.getRow(i));

            tail.push(keys.map(function (k) {
              return _this.valueToString(data[k]);
            }));
          };

          for (var i = Math.max(4, _this.reader.getRowCount() - 2); i <= _this.reader.getRowCount(); i++) {
            _loop_2(i);
          }

          var prev = {
            count: _this.reader.getRowCount(),
            head: head,
            tail: tail,
            headers: headers
          };
          res(prev);
        });
      }
    });
  };

  GenericImporter.prototype.valueToString = function (v) {
    if (v) {
      if (v instanceof Date) {
        return moment_1.default.utc(v).format("DD/MM/YYYY HH:mm");
      }

      var r = v.toString();

      if (r.length > 30) {
        return r.substr(0, 30) + "...";
      }

      return r;
    }

    return "";
  };

  GenericImporter.prototype.rowToData = function (row) {
    var e_3, _a;

    var data = {};

    try {
      for (var _b = __values(this.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
        var _d = __read(_c.value, 2),
            key = _d[0],
            field = _d[1];

        if (field.map && row[field.map]) {
          if (field.parser instanceof utils_1.StringParserClass) {
            data[key] = field.parser.fromString(row[field.map]);
          } else {
            data[key] = field.parser(row[field.map]);
          }
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return data;
  };

  return GenericImporter;
}(events_1.EventEmitter);

exports.GenericImporter = GenericImporter;